var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('carousel',{attrs:{"navigationEnabled":"","perPageCustom":[
    [320, 3],
    [480, 3],
    [768, 10],
    [1199, 6] ]}},_vm._l((_vm.sponsors.data),function(sponsor){return _c('slide',{key:sponsor.id},[_c('figure',{staticClass:"image is-64x64 mx-4"},[_c('img',{staticClass:"is-rounded",attrs:{"src":_vm.img(sponsor.name_image),"alt":sponsor.name,"title":sponsor.name}})])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }